import script from "./student-order-history-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./student-order-history-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__